import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import type {
  ScheduleSummary,
  ScheduleDetail,
  CreateScheduleRequest,
  UpdateScheduleRequest,
  CreateTimeSlotRequest,
  TimeZoneSummary,
  TimeZoneDetail,
} from './configuration.types';

const base = '/api/Configuration';

// Schedules
export function listSchedules(): Promise<ApiResponse<ScheduleSummary[]>> {
  return apiClient.get<ScheduleSummary[]>(`${base}/schedules`);
}

export function createSchedule(payload: CreateScheduleRequest): Promise<ApiResponse<ScheduleDetail>> {
  return apiClient.post<ScheduleDetail>(`${base}/schedules`, payload);
}

export function getSchedule(id: string | number): Promise<ApiResponse<ScheduleDetail>> {
  return apiClient.get<ScheduleDetail>(`${base}/schedules/${encodeURIComponent(id)}`);
}

export function updateSchedule(id: string | number, payload: UpdateScheduleRequest): Promise<ApiResponse<ScheduleDetail>> {
  return apiClient.put<ScheduleDetail>(`${base}/schedules/${encodeURIComponent(id)}`, payload);
}

export function deleteSchedule(id: string | number): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`${base}/schedules/${encodeURIComponent(id)}`);
}

// Time Slots
export function createTimeSlot(scheduleId: string | number, payload: CreateTimeSlotRequest): Promise<ApiResponse<ScheduleDetail>> {
  return apiClient.post<ScheduleDetail>(`${base}/schedules/${encodeURIComponent(scheduleId)}/timeslots`, payload);
}

export function deleteTimeSlot(scheduleId: string | number, timeslotId: string | number): Promise<ApiResponse<ScheduleDetail>> {
  return apiClient.delete<ScheduleDetail>(`${base}/schedules/${encodeURIComponent(scheduleId)}/timeslots/${encodeURIComponent(timeslotId)}`);
}

// Time Zones
export function listTimeZones(): Promise<ApiResponse<TimeZoneSummary[]>> {
  return apiClient.get<TimeZoneSummary[]>(`${base}/timezones`);
}

export function getTimeZone(id: string): Promise<ApiResponse<TimeZoneDetail>> {
  return apiClient.get<TimeZoneDetail>(`${base}/timezones/${encodeURIComponent(id)}`);
}